import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DragRef, Point } from '@angular/cdk/drag-drop';
import { TimerService, TimerState } from 'src/app/services/timer/timer.service';

@Component({
    selector: 'app-timer',
    templateUrl: './timer.component.html',
    styleUrls: ['./timer.component.scss'],
    standalone: false,
})
export class TimerComponent implements OnInit, OnDestroy {
    timerState: TimerState = {
        isRunning: false,
        isPaused: false,
        elapsedTime: 0,
        taskName: '',
        projectName: '',
        projectId: '',
        taskId: '',
        taskNumber: '',
    };
    private timerSubscription: Subscription | null = null;
    private themeSubscription: Subscription | null = null;
    isModernTheme: boolean = true;

    constructor(public timerService: TimerService, private elementRef: ElementRef, private router: Router) { }

    constrainPosition = (point: Point, dragRef: DragRef): Point => {
        const { width, height } = this.elementRef.nativeElement.querySelector('.timer-container').getBoundingClientRect();
        const { innerWidth, innerHeight } = window;

        const minX = 10;
        const maxX = innerWidth - width - 10;
        const minY = 80;
        const maxY = innerHeight - height - 10;

        return {
            x: Math.min(Math.max(point.x, minX), maxX),
            y: Math.min(Math.max(point.y, minY), maxY)
        };
    }

    navigateToProject() {
        console.log('navigateToProject clicked. Current State:', this.timerState);
        if (this.timerState.projectId) {
            console.log('Navigating to project:', this.timerState.projectId);
            this.router.navigate(['/admin/projects/details'], { queryParams: { id: this.timerState.projectId } });
        } else {
            console.warn('No projectId in timerState');
        }
    }

    navigateToTask() {
        console.log('navigateToTask clicked. Current State:', this.timerState);
        if (this.timerState.projectId && this.timerState.taskNumber) {
            console.log('Navigating to task:', this.timerState.taskNumber, 'in project:', this.timerState.projectId);
            this.router.navigate(['/admin/projects/details'], { queryParams: { id: this.timerState.projectId, task: this.timerState.taskNumber } });
        } else {
            console.warn('Missing projectId or taskNumber in timerState');
        }
    }

    ngOnInit(): void {
        this.timerSubscription = this.timerService.timerState$.subscribe(
            (state) => {
                this.timerState = state;
            }
        );

        this.themeSubscription = this.timerService.isModernTheme$.subscribe(
            (isModern) => {
                this.isModernTheme = isModern;
            }
        );
    }

    ngOnDestroy(): void {
        this.timerSubscription?.unsubscribe();
        this.themeSubscription?.unsubscribe();
    }

    formatTime(seconds: number): string {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return [hours, minutes, secs]
            .map((v) => (v < 10 ? '0' + v : v))
            .join(':');
    }

    onPauseResume() {
        if (this.timerState.isPaused) {
            this.timerService.resumeTimer();
        } else {
            this.timerService.pauseTimer();
        }
    }

    onStop() {
        this.timerService.stopTimer();
    }
}
